import React from 'react';
import { Box, Button, Chip, Dialog, DialogActions, IconButton, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';

const DialogButton = ({ children, tooltipTitle = '', buttonTitle, fullWidth = true }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      {buttonTitle ? (
        <Chip onClick={handleClickOpen} label={buttonTitle} color="primary" />
      ) : (
        <Tooltip title={tooltipTitle}>
          <IconButton onClick={handleClickOpen}>
            <Icon icon="eva:more-vertical-fill" />
          </IconButton>
        </Tooltip>
      )}

      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth={fullWidth}>
        <Box>{children}</Box>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DialogButton;
